import styled from 'styled-components';

import { ActionButton } from 'components/ui/Button';

export const StyledAbandonButton = styled(ActionButton)`
  margin-left: 10px;
`;
